import {
  // blackColor,
  grayColor,
  whiteColor,
  dangerColor,
  successColor,
  // hexToRgb,
  blendColors,
  cardTitle,
  warningColor,
  infoColor,
} from "assets/jss/material-dashboard-pro-react.js";
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
const initiativesStyle = (theme) => ({
  ...customSelectStyle(theme),
  ...customInputStyle(theme),
  ...modalStyle(theme),
  cardsWrapper: {
    width: "100%",
  },
  fullHeight: {
    marginTop: "-15px",
    height: "100%",
  },
  cardTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px",
    paddingBottom: "3px",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  cardCategory: {
    color: "#ffffff",
    fontSize: "14px",
    paddingTop: "5px",
    marginBottom: "0",
    marginTop: "0",
    margin: "0",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "&.italic": {
      fontStyle: "italic !important",
      paddingRight: "4px",
    },
  },
  cardIcon: {
    marginTop: "-12px !important",
    padding: "0 !important",
  },
  card: {
    marginTop: "10px",
    [theme.breakpoints.down("xs")]: {
      marginTop: "5px",
      marginBottom: "0",
    },
    "&.newInitiative": {
      border: "1px " + theme.palette.custom.clientColor + " solid",
    },
  },
  verySmall: {
    color: grayColor[1],
    fontSize: "12px",
  },
  cardsFullHeight: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  initiativesCard: {
    marginTop: "2px",
    // height: "100%",
    [theme.breakpoints.down("xs")]: {
      marginTop: "21px",
    },
  },
  initiativesCardBodyTableView: {
    padding: "12px 0",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      height: "100%",
      position: "relative",
    },
  },
  initiativesWrapperTableView: {
    fontSize: "12px",
    width: "100%",
    flex: "1",
    overflowY: "auto",
  },
  initiativesRow: {
    display: "flex",
    width: "100%",
    paddingTop: "2px",
    paddingBottom: "0",
    "&:not($initiativesHeader)": {
      backgroundColor: whiteColor,
      cursor: "pointer",
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: grayColor[8],
      },
    },
    borderBottom: "1px #eee solid",
    "&.selected": {
      color: whiteColor,
      backgroundColor: theme.palette.custom.clientColor + " !important",
      "&:hover": {
        backgroundColor: theme.palette.custom.clientColor + "cc !important",
      },
    },
  },
  initiativesHeader: {
    fontWeight: "bold",
    cursor: "pointer",
    color: whiteColor,
    backgroundColor: grayColor[6],
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    fontSize: "1.5vmin",
    "& > div": {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
  },
  initiativeShortDescription: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    width: "37%",
    paddingLeft: "4px",
  },
  initiativeLeader: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    textAlign: "center",
    width: "23%",
  },
  initiativeBenefit: {
    textAlign: "center",
    width: "16%",
  },
  initiativeGlobalBenefit: {
    textAlign: "center",
    width: "18%",
  },
  initiativeBenefitStart: {
    textAlign: "center",
    width: "16%",
  },
  initiativeStatus: {
    textAlign: "center",
    width: "9%",
  },
  initiativeStatusColor: {
    "&:before": {
      fontFamily: "'Font Awesome 5 Free'",
      fontWeight: "900",
      fontSize: "1.85vmin",
      color: grayColor[4],
      textShadow: "#999 0 0 3px",
    },
    "&.selected": {
      "&:before": {
        textShadow: "#fff 0 0 3px !important",
      },
    },
    "&.status-active": {
      "&.trafficLight1": {
        "&:before": {
          color: successColor[0],
          content: "'\\f111'",
        },
      },
      "&.trafficLight2": {
        "&:before": {
          color: warningColor[7],
          content: "'\\f111'",
        },
      },
      "&.trafficLight3": {
        "&:before": {
          color: dangerColor[0],
          content: "'\\f111'",
        },
      },
    },
    "&.status-on_hold": {
      "&:before": {
        color: grayColor[6],
        content: "'\\f28b'",
      },
    },
    "&.status-cancelled": {
      "&:before": {
        color: dangerColor[3],
        content: "'\\f057'",
      },
    },
    "&.status-finished": {
      "&:before": {
        color: infoColor[4],
        content: "'\\f058'",
      },
    },
  },
  initiativeSorted: {
    "&:after": {
      fontSize: "1.5vmin",
      padding: "0 0 0 3px",
      content: "'\\25cf'",
    },
  },
  initiativeDate: {
    textAlign: "center",
    width: "8%",
    "&.critical": {
      "&.selected": {
        color: blendColors(dangerColor[0], whiteColor, 0.25),
      },
      "&:not(.selected)": {
        color: dangerColor[0],
      },
    },
  },
  inputDescription: {
    fontSize: "11px",
    marginBottom: "-2px",
  },
  timeline: {
    paddingTop: "0",
    position: "relative",
    "& ul": {
      marginTop: "5px !important",
    },
  },
  followUpWrapper: {
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    padding: "0 5px 0 15px",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: grayColor[5],
      borderRadius: "4px",
    },
  },
  cardButton: {
    padding: "0 !important",
    margin: "10px 0 0 10px !important",
    height: "22px !important",
    width: "30px !important",
    minWidth: "0 !important",
    position: "relative",
    transition: "all 0.2s",
  },
  cardButtonIcon: {
    margin: "0 !important",
    position: "absolute !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%)",
    width: "18px !important",
    height: "18px !important",
  },
  inputAdornment: {
    marginRight: "8px",
    position: "relative",
  },
  inputAdornmentIconSuccess: {
    color: successColor[0] + "!important",
  },
  inputAdornmentIconError: {
    color: dangerColor[0] + "!important",
  },
  initiativesSpinner: {
    height: "100%",
    paddingTop: "4px",
    "& > svg": {
      width: "40px !important",
    },
  },
  attention: {
    backgroundColor: warningColor[0] + " !important",
    animation: "$attention 3s ease infinite",
  },
  "@keyframes attention": {
    "10%": {
      transform: "scale(1.1)",
    },
    "13.33%,20%": {
      transform: "rotate(-10deg) scale(1.1)",
    },
    "16.67%": {
      transform: "rotate(10deg) scale(1.1)",
    },
    "23.33%": {
      transform: "rotate(0deg) scale(1.1)",
    },
    "33%": {
      transform: "scale(1)",
    },
  },
  fupUserName: {
    color: grayColor[0],
  },
  fupDaysAgo: {
    textTransform: "lowercase",
  },
  invisible: {
    opacity: "0",
    pointerEvents: "none",
  },
  topCardShortSpacing: {
    margin: "0px",
  },
  topCardBody: {
    paddingTop: "5px !important",
    paddingBottom: "5px !important",
    paddingLeft: "0px !important",
  },
  refreshIcon: {
    color: grayColor[1],
    marginBottom: "5px",
    marginLeft: "-20px",
    fontSize: "18px",
    cursor: "pointer",
    transition: "transform 150ms",
    "&:hover": {
      transform: "rotate(180deg)",
    },
  },
  stepsContainer: {
    height: "97%",
    backgroundColor: grayColor[8],
    // borderRadius: "4px",
    padding: "20px 5px 15px 15px",
    margin: "0 -15px",
    overflow: "hidden",
  },
  cardHeaderHover: {
    transition: "all 300ms cubic-bezier(0.34, 1.61, 0.7, 1)",
    height: "100%",
    "& > div": {
      height: "100%",
      transition: "all 300ms cubic-bezier(0.34, 1.61, 0.7, 1)",
    },
  },
  drawerContent: {
    padding: "15px",
    height: "88vh",
    overflowY: "hidden",
    "& .makeStyles-timelineSimple-6417": {
      marginTop: "5px",
    },
  },
  drawer: {
    "& .MuiDrawer-root": {
      zIndex: 1200,
    },
    "& .MuiDrawer-paper": {
      zIndex: 1200,
      overflowY: "hidden",
    },
    "& .MuiBackdrop-root": {
      zIndex: 1199,
    },
  },
  chartCard: {
    height: "100%",
    "& .ct-chart": {
      padding: "0px",
    },
    marginBottom: "10px",
    backgroundColor: "transparent",
    "&:first-of-type": {
      marginTop: "-5px",
    },
  },
  drawerHeader: {
    borderBottom: "none",
    padding: "12px 12px 0 12px",
  },
  drawerTitle: {
    fontSize: "1.1rem",
    fontWeight: "300",
    marginBottom: "4px",
    color: grayColor[6],
  },
  drawerSubtitle: {
    fontSize: "0.875rem",
    color: grayColor[0],
    fontStyle: "italic",
    lineHeight: "1.3",
    marginBottom: "8px",
  },
  viewButtonsContainer: {
    position: "absolute",
    right: "0",
    top: "50%",
    transform: "translate(0,-50%)",
    display: "flex",
  },
  viewButton: {
    margin: "0 !important",
    position: "relative",
    boxShadow: "0 0 2px rgba(0, 0, 0, 0.3) !important",
    padding: "3px 8px !important",
    height: "20px",
  },
  viewButtonArrow: {
    margin: "5px 0 5px !important",
    position: "relative",
    boxShadow: "0 0 2px rgba(0, 0, 0, 0.3) !important",
    padding: "16px 6px !important",
    height: "24px !important",
  },
  firstButton: {
    borderTopRightRadius: "0 !important",
    borderBottomRightRadius: "0 !important",
    float: "left",
  },
  middleButton: {
    borderRadius: "0 !important",
  },
  lastButton: {
    borderTopLeftRadius: "0 !important",
    borderBottomLeftRadius: "0 !important",
  },
  firstButtonDate: {
    borderTopRightRadius: "0 !important",
    borderBottomRightRadius: "0 !important",
    float: "left",
    color: "#555555 !important",
    backgroundColor: "#ffffff",
  },
  middleButtonDate: {
    borderRadius: "0 !important",
    color: "#555555 !important",
    backgroundColor: "#ffffff",
  },
  lastButtonDate: {
    borderTopLeftRadius: "0 !important",
    borderBottomLeftRadius: "0 !important",
    color: "#555555 !important",
    backgroundColor: "#ffffff",
  },
  buttonSelected: {
    pointerEvents: "none",
  },
  buttonSelectedDate: {
    pointerEvents: "none",
    backgroundColor: "#555555 !important",
    color: "#ffffff !important",
  },
  miniWrapper: {
    paddingTop: 8,
  },
  miniItemAccordion: {
    display: "flex",
    alignItems: "center",
    padding: "6px",
    marginBottom: "2px",
    cursor: "pointer",
    borderRadius: "1px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: grayColor[13],
      transform: "translateX(2px)",
    },
  },
  miniItemSelectedAccordion: {
    backgroundColor: grayColor[10],
    "&:hover": {
      backgroundColor: grayColor[10],
    },
  },
  ellipsisTextMiniAccordion: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: "0",
    color: grayColor[6],
    lineHeight: 1.3,
  },
  miniStageHeaderAccordion: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "transparent",
    borderTop: "1px solid " + grayColor[8],
    marginTop: "2px",
    padding: 0,
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontWeight: 400,
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: grayColor[13],
    },
  },
  miniStageExpandIcon: {
    color: grayColor[7],
    "&:hover,&:focus": {
      color: grayColor[6],
    },
  },
  miniStageTitleAccordion: {
    paddingLeft: "5px",
    color: grayColor[7],
    "&:hover,&:focus": {
      color: grayColor[6],
    },
  },
  miniStageCountAccordion: {
    color: grayColor[7],
    fontSize: "11px",
    fontWeight: 400,
    padding: 2,
  },
  modalBody: {
    ...modalStyle(theme).modalBody,
    padding: "16px 24px !important",
  },
  selectFormControlStage: {
    margin: "-9px 0 17px 0 !important",
    "& > div": {
      "&:before": {
        borderBottomWidth: "1px !important",
        borderBottomColor: grayColor[4] + "!important",
      },
      "&:after": {
        borderBottomColor: theme.palette.custom.clientColor + "!important",
      },
    },
    "& .MuiSelect-select": {
      color: grayColor[0] + " !important",
      textTransform: "none !important",
    },
  },
  pnlSelectorContainer: {
    display: "flex",
    alignItems: "center",
    height: "35px",
    marginTop: "-8px",
    borderBottom: "1px solid " + grayColor[4],
    transition: "border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  },
  pnlSelectorButton: {
    padding: "0 !important",
    margin: "0 4px 0 0 !important",
    width: "28px !important",
    height: "28px !important",
    color: grayColor[6] + " !important",
    "&:hover": {
      color: theme.palette.custom.clientColor + " !important",
    },
  },
  pnlSelectorDisplay: {
    flexGrow: 1,
    fontSize: "14px",
    color: grayColor[0],
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "& i": {
      color: grayColor[7],
      fontSize: "13px",
    },
  },
  tagWrapper: {
    display: "inline-block",
    marginRight: "1px",
    marginTop: "3px",
    marginBottom: "3px",
  },
});

export default initiativesStyle;
